import { type IconProps } from './types';
export const UpdateIcon = ({
  size = 24,
  color = 'currentColor',
  bgColor = 'transparent',
  id,
  ...props
}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    id={id}
    fill={color}
    stroke={bgColor}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M18.308 7.497a7.75 7.75 0 0 0-14.016 3.69.75.75 0 0 1-1.492-.16A9.24 9.24 0 0 1 7.375 3.99c4.17-2.408 9.435-1.2 12.165 2.653l.242-.902a.75.75 0 1 1 1.449.388l-.732 2.732a.75.75 0 0 1-.919.53l-2.732-.732a.75.75 0 0 1 .388-1.448zm2.224 4.65a.75.75 0 0 1 .667.825 9.24 9.24 0 0 1-4.575 7.039c-4.17 2.408-9.435 1.2-12.165-2.652l-.241.901a.75.75 0 1 1-1.45-.388l.733-2.732a.75.75 0 0 1 .918-.53l2.732.732a.75.75 0 0 1-.388 1.449l-1.072-.288a7.75 7.75 0 0 0 14.016-3.69.75.75 0 0 1 .825-.666"
      clipRule="evenodd"
    />
  </svg>
);
